import { qualityPoints } from "@/mocks/home";

export default function Quality() {
  return (
    <section id="quality" className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20of%20a%20vintage%20film%20strip%20and%20projector%20lens%20glowing%20with%20warm%20amber%20light%20in%20a%20dark%20room%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20rich%20warm%20tones%2C%20high%20detail&width=900&height=700&seq=sister-friend-quality-01&orientation=landscape"
                alt="暖光下的胶片与投影镜头，象征画质与资源质量"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
              高清完整版
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
              高清完整版的“高清”，究竟指什么
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              “高清”描述的是画面质量，与内容是否完整是两件事。下面四个维度决定了实际观感，
              但它们不一定都会写在标题里，需要你用参数去核对。
            </p>

            <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {qualityPoints.map((point) => (
                <div
                  key={point.id}
                  className="rounded-lg bg-background-50 border border-background-200 p-5"
                >
                  <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                    <i className={`${point.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}